var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEndCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 8.90962C22.1905 9.06141 22.8109 9.43857 23.2635 9.98169C23.7161 10.5248 23.9752 11.2031 24 11.9096V13.4096C23.9961 13.9388 23.7841 14.4453 23.4099 14.8195C23.0357 15.1937 22.5292 15.4057 22 15.4096H19C18.4709 15.4054 17.9646 15.1934 17.5904 14.8192C17.2162 14.445 17.0042 13.9388 17 13.4096V12.4096C14.0072 12.1156 10.9928 12.1156 8 12.4096V13.4096C7.99607 13.9388 7.7841 14.4453 7.40988 14.8195C7.03565 15.1937 6.52922 15.4057 6 15.4096H3C2.47078 15.4057 1.96435 15.1937 1.59012 14.8195C1.2159 14.4453 1.00393 13.9388 1 13.4096V11.9096C1.02479 11.2031 1.28388 10.5248 1.73649 9.98169C2.18909 9.43857 2.8095 9.06141 3.5 8.90962C9.43871 7.69679 15.5613 7.69679 21.5 8.90962Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndCall);
export default __webpack_public_path__ + "static/media/End-call.71ebd258.svg";
export { ForwardRef as ReactComponent };